export enum CriticalType {
  BAJA = 'BAJA',
  MEDIA = 'MEDIA',
  ALTA = 'ALTA',
}

export enum ProjectType {
  STAFF_AUGMENTATION = 'STAFF_AUGMENTATION',
  PRODUCT_BUILDING = 'PRODUCT_BUILDING',
}

export interface ProjectFormProps {
  children?: JSX.Element;
}
